import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import React, { useEffect, useState } from 'react';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import UploadIcon from '@mui/icons-material/Upload';
import Xmltojson from '../XMLtoJSON/Xmltojson';
import CloseIcon from '@mui/icons-material/Close';
import ProgramDirectoryVersion from './ProgramDirectoryVersion';
import SearchIcon from '@mui/icons-material/Search';

var token = getCookie("bb_metaverse_token");
var user = JSON.parse(getCookie("bb_metaverse_user"));


const ProgramDirectory = (props) => {

    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(true)
    const { enqueueSnackbar } = useSnackbar();
    const [openRow, setOpenRow] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [rowData, setRowData] = useState({});
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [addProgramData, setProgramData] = useState({});
    const [search, setSearch] = useState('');
    const [columns] = useState([
        { title: 'Name', field: 'name', },
        { title: 'Description', field: 'description', },
        {
            title: 'Date Created', field: 'date_created', editable: 'never',
            render: rowData => rowData.date_created ? moment(rowData.date_created).format('DD-MM-YYYY') : ''
        },

    ])



    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = () => {
        Service.get(`/api/program/version/get_project_program_directory_and_versions/?project_id=${props.data?.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setTableData(res.data)
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    const addProgram = () => {
        if (!addProgramData.name || !addProgramData.description) {
            enqueueSnackbar('Please fill all the fields!', {
                variant: 'warning'
            });
            return;
        } else {
            let data = addProgramData;
            data.project = props.data?.id;
            data.created_by = user.id
            Service.post(`/api/program/schedule/create_program_directory/`, {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data,
            })
                .then(res => {
                    setLoading(true)
                    getData()
                    enqueueSnackbar('Program Directory added successfully!', {
                        variant: 'success'
                    });
                    setAddDialogOpen(false)
                })
                .catch(error => {
                    console.log(error)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    const handleClose = () =>{
        setDialogOpen(false)
        getData()
    }

    const filteredTableData = tableData.filter(row =>
        columns.some(column => String(column.render ? column.render(row) : row[column.field] || '').toLowerCase().includes(search.toLowerCase()))
    )

    return (
        <div>
            {loading ? <Box display='flex' justifyContent='center' alignItems='center' width='100%'><CircularProgress /></Box> :
                <div>
                    <TableContainer component={Paper}>
                        <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                            <Typography variant="h5">{props.data?.name}</Typography>
                            <Box display='flex' alignItems='center' gap={1}>
                                <TextField
                                    size='small'
                                    variant='outlined'
                                    placeholder='Search'
                                    value={search}
                                    onChange={(event) => setSearch(event.target.value)}
                                    InputProps={{ endAdornment: <SearchIcon /> }}
                                />
                                <Button onClick={() => setAddDialogOpen(true)} ><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                            </Box>
                        </Box>
                        <Table>
                            <TableHead>
                                <TableRow >
                                    <TableCell />
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredTableData && filteredTableData.map((row, idx) => (
                                    <React.Fragment key={row.key || idx}>
                                        <TableRow key={row.id}>
                                            {row.program_versions.length > 0 ?
                                                <TableCell>
                                                    <Tooltip title="Open Directory">
                                                        <IconButton size='small' color='primary' onClick={() => { if (openRow === row.id) { setOpenRow(null) } else { setRowData(row); setOpenRow(row.id) } }} >
                                                            {openRow === row.id ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell> : <TableCell />}
                                            {columns && columns.map((column) => (
                                                <TableCell>{column.render ? column.render(row) : row[column.field]}</TableCell>
                                            ))}
                                            <TableCell>
                                                <Tooltip title='Upload Program'>
                                                    <IconButton size='small' color='primary' onClick={() => { setDialogOpen(true); setRowData(row) }} >
                                                        <UploadIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                                                <Collapse in={openRow === row.id} timeout="auto" unmountOnExit>
                                                    <Box width='100%'>
                                                        <ProgramDirectoryVersion rowData={rowData} />
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Dialog open={dialogOpen} maxWidth="xs" fullWidth={true} onClose={() => setDialogOpen(false)}>
                        <DialogTitle marginTop="2px" spacing={2} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant='h6'>Upload Program</Typography>
                            <IconButton color='error' onClick={() => setDialogOpen(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Xmltojson programDirectory={rowData} close={handleClose} />
                        </DialogContent>
                        {/* <Button size='small' color='primary' onClick={() => setDialogOpen(false)}>Close</Button> */}
                    </Dialog>
                    <Dialog open={addDialogOpen} maxWidth="xs" fullWidth={true} onClose={() => setAddDialogOpen(false)}>
                        <DialogTitle marginTop="2px" spacing={2} display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant='h6'> Add New Program Directory</Typography>
                            <IconButton color='error' onClick={() => setAddDialogOpen(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Box display={'flex'} flexDirection='column' justifyContent={'center'} alignItems={'center'} width='100%'>
                                <TextField label="Name" variant="outlined" fullWidth sx={{ mb: 2 }} value={addProgramData.name} onChange={(e) => setProgramData({ ...addProgramData, name: e.target.value })} />
                                <TextField label="Description" variant="outlined" fullWidth sx={{ mb: 2 }} value={addProgramData.description} onChange={(e) => setProgramData({ ...addProgramData, description: e.target.value })} />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button size='small' color='primary' onClick={() => addProgram()}>Add</Button>
                        </DialogActions>
                    </Dialog>
                </div>}
        </div>
    )
}

export default ProgramDirectory